<template>
  <nav v-show="finalList.length>1">
    <ul>
      <li>
        <a class="button w-button black">{{title}} ⌄</a>
        <!-- First Tier Drop Down -->
        <ul>
          <li v-for="(item,i) in finalList" :key="i">
            <a @click="showField(item.slug)" href="#">
              {{item.name}}
              <i v-if="item.show" class="smIcon"></i>
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "dropdown",
  props: ["schema", "title"],
  data() {
    return {
      lisVal: this.schema
    };
  },
  methods: {
    showField(slg) {
      var arr = this.schema;
      var el = arr.find(e => {
        return e.slug == slg;
      });
      var index = arr.indexOf(el);
      arr[index].show = !arr[index].show;
      this.$emit("showField", {
        slug: arr[index].slug,
        status: arr[index].show
      });
      Vue.set(this.lisVal, index, arr[index]);
    }
  },
  computed: {
    finalList() {
      var itemlist = this.schema.filter(e => {
        return (
          (e.type == "PlainText" || e.type == "Option") &&
          e.slug != "slug" &&
          e.slug != "name" &&
          !e.name.match(/^\-/)
        );
      });
      console.log(itemlist.length > 1);
      return itemlist;
    }
  }
};
</script>

<style scoped>
nav {
  display: inline-block;
}
nav ul {
  padding: 0;
  margin: 0;
  list-style: none;
  position: relative;
}
.smIcon {
  float: right;
  font-size: 8px;
  font-family: "bagelfont";
  border-radius: 100%;
}
nav ul li ul li {
  display: inline-block;
  background: #2d3035;
  line-height: 40px;
  text-align: left;
}

nav a {
  display: block;
  padding: 0 10px;
  color: #fff;
  text-decoration: none;
}

nav a:hover {
  background-color: #000000;
}

/* Hide Dropdowns by Default */
nav ul ul {
  display: none;
  position: absolute;
  top: 35px; /* the height of the main nav */
}

/* Display Dropdowns on Hover */
nav ul li:hover > ul {
  display: inherit;
}

/* Fisrt Tier Dropdown */
nav ul ul li {
  width: 170px;
  float: none;
  display: list-item;
  position: relative;
}

/* Second, Third and more Tiers	*/
nav ul ul ul li {
  position: relative;
  top: -60px;
  left: 170px;
}

/* Change this in order to change the Dropdown symbol */
li > a:only-child:after {
  content: "";
}
</style>
